/**
 * Product Add-On Selector: Adds selected add-on product variants to cart
 * before the main product, so main product appears on top in cart.
 *
 * Speed: all add-ons go in ONE /cart/add.js call instead of one call each.
 * Shopify's cart API takes an items array, so N add-ons cost 1 round trip
 * rather than N. With the GEN 2.0 gift pack (3 free items) that is 4 sequential
 * requests down to 2.
 *
 * Resilience: a batched add is all-or-nothing — if one variant is out of stock
 * Shopify rejects the whole call. So on failure we fall back to the original
 * one-at-a-time behaviour, which skips only the item that actually failed.
 */
(function() {
  if (!document.querySelector('[data-addon-select]')) return;

  var originalFetch = window.fetch;

  function addBatch(items) {
    return originalFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
      _isAddon: true
    }).then(function (r) {
      if (!r || !r.ok) throw new Error('batch add rejected');
      return r;
    });
  }

  function addOneByOne(items) {
    var chain = Promise.resolve();
    for (var k = 0; k < items.length; k++) {
      (function (item) {
        chain = chain.then(function () {
          return originalFetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [item] }),
            _isAddon: true
          }).catch(function () { /* skip failed addon */ });
        });
      })(items[k]);
    }
    return chain;
  }

  window.fetch = function(url, options) {
    var urlStr = typeof url === 'string' ? url : (url && url.url ? url.url : '');

    if (urlStr.includes('/cart/add') && options && !options._isAddon) {
      var extras = getSelectedAddons();
      if (extras.length) {
        var self = this;
        var args = arguments;
        var first = extras.length > 1 ? addBatch(extras) : addOneByOne(extras);
        return first
          .catch(function () {
            /* one of them failed — retry individually so the rest still land */
            return addOneByOne(extras);
          })
          .then(function () {
            return originalFetch.apply(window, [url, options]);
          });
      }
    }
    return originalFetch.apply(this, arguments);
  };

  function getSelectedAddons() {
    var selects = document.querySelectorAll('[data-addon-select]');
    var items = [];
    for (var i = 0; i < selects.length; i++) {
      var selectedOption = selects[i].options[selects[i].selectedIndex];
      // Check for multi-product add (e.g. A & D-Type adds both couplers)
      var multi = selectedOption && selectedOption.getAttribute('data-addon-multi');
      if (multi) {
        var ids = multi.split(',');
        for (var j = 0; j < ids.length; j++) {
          items.push({ id: parseInt(ids[j]), quantity: 1 });
        }
      } else {
        var val = selects[i].value;
        if (val) {
          items.push({ id: parseInt(val), quantity: 1 });
        }
      }
    }
    return items;
  }
})();
